export default {
  "title": "Aviso de privacidad del sitio web",
  "lastUpdated": "Última actualización: 26 de mayo de 2026",
  "back": "← Volver al inicio",
  "intro": [
    {
      "type": "h3",
      "text": "Acerca de este aviso de privacidad"
    },
    {
      "type": "p",
      "text": "Su privacidad es importante para nosotros."
    },
    {
      "type": "p",
      "text": "Este aviso de privacidad del sitio web explica cómo Demakstore Gıda İhracat San. ve Tic. Ltd. Şti., que opera bajo la marca DeMaxtore («DeMaxtore», «nosotros», «nuestro»), recopila y trata datos personales a través de su uso de www.demaxtore.com."
    },
    {
      "type": "p",
      "text": "Esto incluye cualquier dato personal que pueda proporcionar cuando usted:"
    },
    {
      "type": "ul",
      "items": [
        "Visita o navega por nuestro sitio web",
        "Crea o utiliza una cuenta",
        "Envía una solicitud de abastecimiento",
        "Utiliza CommodityBid",
        "Utiliza FreightIQ",
        "Solicita servicios de inspección",
        "Solicita soporte de seguimiento de envíos en vivo",
        "Nos contacta mediante formularios, correo electrónico, WhatsApp, teléfono, SMS u otros canales",
        "Presenta su empresa, productos o servicios en nuestra plataforma",
        "Se comunica con DeMaxtore como comprador, proveedor, fabricante, transitario, socio de inspección u otro socio comercial"
      ]
    },
    {
      "type": "p",
      "text": "Este aviso explica qué datos personales tratamos, por qué, cuánto tiempo los conservamos, con quién podemos compartirlos y qué derechos tiene."
    }
  ],
  "sections": [
    {
      "title": "1. ¿Quién es responsable de sus datos personales?",
      "blocks": [
        {
          "type": "p",
          "text": "El responsable del tratamiento de sus datos personales es:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marca operativa: DeMaxtore",
            "Sitio web: www.demaxtore.com",
            "Correo electrónico: support@demaxtore.com",
            "Correo alternativo: demaxtore@demaxtore.com"
          ]
        },
        {
          "type": "p",
          "text": "A efectos de este aviso, DeMaxtore se refiere a la marca y plataforma operadas por Demakstore Gıda İhracat San. ve Tic. Ltd. Şti."
        }
      ]
    },
    {
      "title": "2. ¿Qué datos personales recopilamos?",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos recopilar y tratar las siguientes categorías de datos personales:"
        },
        {
          "type": "h3",
          "text": "Información de identificación"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Nombre completo",
            "Nombre del representante de la empresa",
            "Imagen de perfil, si se proporciona",
            "Información de identificación o verificación, cuando la ley lo exija"
          ]
        },
        {
          "type": "h3",
          "text": "Información de contacto comercial"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Correo electrónico comercial",
            "Número de teléfono",
            "Cargo",
            "Departamento",
            "Nombre de la empresa",
            "Sitio web de la empresa",
            "País y ciudad",
            "Dirección comercial, si se proporciona"
          ]
        },
        {
          "type": "h3",
          "text": "Información de empresa y proveedor"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Perfil de empresa",
            "Categorías de productos",
            "Especificaciones de producto",
            "Capacidades de fabricación",
            "Certificaciones",
            "Detalles de verificación del proveedor",
            "Rol de comprador o proveedor"
          ]
        },
        {
          "type": "h3",
          "text": "Información de abastecimiento y licitación"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Solicitudes de abastecimiento",
            "Solicitudes CommodityBid",
            "Cantidad, embalaje, precio objetivo y requisitos de entrega",
            "Ofertas de proveedores",
            "Comunicaciones comprador/proveedor",
            "Detalles de comparación de ofertas"
          ]
        },
        {
          "type": "h3",
          "text": "Información logística y de envío"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Detalles de solicitud de flete",
            "Información de recogida y entrega",
            "Tipo de carga y detalles del envío",
            "Datos de comparación FreightIQ",
            "Ofertas de transitarios",
            "Actualizaciones de seguimiento",
            "Información logística puerta a puerta"
          ]
        },
        {
          "type": "h3",
          "text": "Información de inspección"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Detalles de solicitud de inspección",
            "Ubicación de fábrica o proveedor",
            "Requisitos de calidad del producto",
            "Informes de inspección",
            "Fotos, documentos y comunicaciones relacionadas"
          ]
        },
        {
          "type": "h3",
          "text": "Información financiera y transaccional"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Información de facturación",
            "Registros comerciales relacionados con pagos",
            "Datos bancarios, cuando sea necesario",
            "Información contable y fiscal"
          ]
        },
        {
          "type": "h3",
          "text": "Información de cumplimiento"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "KYC / conocimiento del proveedor",
            "Controles antifraude",
            "Cumplimiento comercial",
            "Prevención de blanqueo de capitales",
            "Anticorrupción",
            "Filtrado de sanciones / partes restringidas"
          ]
        },
        {
          "type": "h3",
          "text": "Datos técnicos y de uso"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Dirección IP",
            "Tipo y versión del navegador",
            "Tipo de dispositivo",
            "Sistema operativo",
            "Zona horaria y configuración de ubicación",
            "Datos de uso del sitio",
            "Páginas vistas",
            "Datos de inicio de sesión",
            "Preferencias de cookies y consentimiento",
            "Interacción con funciones del sitio"
          ]
        },
        {
          "type": "h3",
          "text": "Datos de marketing y comunicación"
        },
        {
          "type": "p",
          "text": "Esto puede incluir:"
        },
        {
          "type": "ul",
          "items": [
            "Preferencias de marketing",
            "Preferencias de comunicación",
            "Registros de correo, WhatsApp, SMS, teléfono o formularios",
            "Datos de interacción con campañas"
          ]
        },
        {
          "type": "p",
          "text": "Si cierta información es obligatoria para un servicio, es posible que no podamos prestarlo si no se proporciona la información requerida."
        }
      ]
    },
    {
      "title": "3. ¿Por qué utilizamos sus datos personales?",
      "blocks": [
        {
          "type": "p",
          "text": "Tratamos datos personales para los fines que se indican a continuación:"
        },
        {
          "type": "ul",
          "items": [
            "Proporcionar acceso al sitio web y servicios de DeMaxtore",
            "Crear y gestionar cuentas de compradores, proveedores y socios",
            "Procesar solicitudes de abastecimiento, RFQ y CommodityBid",
            "Comparar ofertas de flete y respaldar FreightIQ",
            "Coordinar inspección y seguimiento de envíos en vivo",
            "Comunicarnos con usuarios, compradores, proveedores y socios logísticos",
            "Verificar información de empresa, proveedor y socio",
            "Proporcionar soporte al cliente y gestionar relaciones comerciales",
            "Mejorar el sitio, los servicios, la búsqueda y la experiencia del usuario",
            "Personalizar recomendaciones relevantes cuando la ley lo permita",
            "Enviar comunicaciones de servicio, transaccionales, legales y de marketing permitidas",
            "Prevenir fraude, uso indebido, spam y actividad no autorizada",
            "Cumplir obligaciones legales, fiscales, contables, regulatorias y de cumplimiento",
            "Proteger los derechos, la seguridad, la reputación y los intereses legítimos de DeMaxtore"
          ]
        }
      ]
    },
    {
      "title": "4. Servicios personalizados y elaboración de perfiles",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore puede utilizar ciertos datos para mejorar la relevancia de resultados de búsqueda, recomendaciones de proveedores, comparaciones de flete o sugerencias de abastecimiento."
        },
        {
          "type": "p",
          "text": "Por ejemplo, podemos analizar:"
        },
        {
          "type": "ul",
          "items": [
            "Consultas de búsqueda",
            "Intereses de producto",
            "Historial de abastecimiento",
            "Categorías solicitadas",
            "Preferencias de país o mercado",
            "Comportamiento de comprador o proveedor",
            "Patrones de uso de la plataforma"
          ]
        },
        {
          "type": "p",
          "text": "Esto puede ayudarnos a ofrecer sugerencias más relevantes de proveedores, categorías, opciones de flete o servicios."
        },
        {
          "type": "p",
          "text": "Cuando este tratamiento requiera consentimiento, lo solicitaremos antes de utilizar dichos datos."
        },
        {
          "type": "p",
          "text": "No utilizamos decisiones automatizadas que produzcan efectos jurídicos o similares significativos sin intervención humana."
        }
      ]
    },
    {
      "title": "5. Comunicaciones de marketing",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos enviar comunicaciones de marketing sobre servicios DeMaxtore, incluidos abastecimiento, CommodityBid, FreightIQ, inspección, seguimiento de envíos y otras soluciones B2B de importación."
        },
        {
          "type": "p",
          "text": "Estas comunicaciones pueden enviarse por:"
        },
        {
          "type": "ul",
          "items": [
            "Correo electrónico",
            "WhatsApp",
            "SMS",
            "Teléfono",
            "Otros canales electrónicos"
          ]
        },
        {
          "type": "p",
          "text": "Puede darse de baja en cualquier momento mediante la opción de cancelación de suscripción o contactándonos en:"
        },
        {
          "type": "p",
          "text": "support@demaxtore.com"
        },
        {
          "type": "p",
          "text": "Incluso después de darse de baja, podemos enviar mensajes importantes relacionados con el servicio, la seguridad, lo legal o transacciones."
        }
      ]
    },
    {
      "title": "6. Enlaces de terceros",
      "blocks": [
        {
          "type": "p",
          "text": "Nuestro sitio puede incluir enlaces a sitios web, herramientas, complementos, aplicaciones, proveedores, fabricantes, logísticos, socios de inspección o plataformas externas."
        },
        {
          "type": "p",
          "text": "Al hacer clic en enlaces de terceros o habilitar integraciones, esos terceros pueden recopilar o tratar datos sobre usted."
        },
        {
          "type": "p",
          "text": "DeMaxtore no controla sitios de terceros ni es responsable de sus prácticas de privacidad. Revise sus avisos de privacidad y políticas de cookies."
        }
      ]
    },
    {
      "title": "7. Cookies y gestión del consentimiento",
      "blocks": [
        {
          "type": "p",
          "text": "Utilizamos cookies y tecnologías similares en www.demaxtore.com para:"
        },
        {
          "type": "ul",
          "items": [
            "Garantizar el funcionamiento del sitio",
            "Recordar sus preferencias de cookies",
            "Mejorar el rendimiento",
            "Analizar el tráfico",
            "Mejorar la experiencia del usuario",
            "Apoyar actividades de marketing y publicidad"
          ]
        },
        {
          "type": "p",
          "text": "Cuando la ley lo exija, solicitamos su consentimiento antes de colocar cookies no esenciales."
        },
        {
          "type": "p",
          "text": "Puede aceptar, rechazar o gestionar sus preferencias mediante nuestro banner o herramienta de preferencias de cookies."
        },
        {
          "type": "p",
          "text": "Para más detalles, consulte nuestra política de cookies por separado."
        }
      ]
    },
    {
      "title": "8. ¿Con quién compartimos sus datos personales?",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos compartir sus datos personales con:"
        },
        {
          "type": "ul",
          "items": [
            "Compradores",
            "Proveedores",
            "Fabricantes",
            "Transitarios",
            "Proveedores logísticos",
            "Proveedores de inspección",
            "Socios de aduanas, documentación o comercio",
            "Proveedores de TI, hosting, CRM, analítica, correo y nube",
            "Proveedores de marketing y comunicación",
            "Asesores legales, contables, de auditoría y cumplimiento",
            "Bancos o proveedores de pago, cuando sea necesario",
            "Autoridades públicas, tribunales, reguladores o fuerzas del orden cuando la ley lo exija"
          ]
        },
        {
          "type": "p",
          "text": "Solo compartimos datos cuando sea necesario para los fines descritos en este aviso o cuando la ley lo exija."
        },
        {
          "type": "p",
          "text": "No vendemos datos personales."
        }
      ]
    },
    {
      "title": "9. Transferencias internacionales de datos",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore opera en comercio internacional; sus datos pueden transferirse o consultarse fuera de su país de residencia."
        },
        {
          "type": "p",
          "text": "Cuando la ley lo exija, utilizamos garantías adecuadas, incluidas medidas contractuales, técnicas, organizativas u otros mecanismos lícitos."
        }
      ]
    },
    {
      "title": "10. ¿Cuánto tiempo conservamos sus datos?",
      "blocks": [
        {
          "type": "p",
          "text": "Conservamos datos personales solo el tiempo necesario para los fines descritos en este aviso."
        },
        {
          "type": "p",
          "text": "Los periodos pueden depender de:"
        },
        {
          "type": "ul",
          "items": [
            "El tipo de datos",
            "La finalidad del tratamiento",
            "La duración de la relación comercial",
            "Obligaciones legales, fiscales, contables o regulatorias",
            "Requisitos de resolución de disputas",
            "Prevención del fraude y seguridad"
          ]
        },
        {
          "type": "p",
          "text": "Cuando ya no sean necesarios, los eliminamos, anonimizamos o archivamos de forma segura."
        }
      ]
    },
    {
      "title": "11. ¿Cómo protegemos sus datos?",
      "blocks": [
        {
          "type": "p",
          "text": "Utilizamos medidas técnicas y organizativas razonables para proteger los datos contra:"
        },
        {
          "type": "ul",
          "items": [
            "Acceso no autorizado",
            "Pérdida",
            "Uso indebido",
            "Alteración",
            "Divulgación",
            "Destrucción",
            "Actividad fraudulenta",
            "Incidentes de seguridad"
          ]
        },
        {
          "type": "p",
          "text": "Ningún servicio en línea puede garantizarse totalmente seguro. Los usuarios deben mantener confidenciales sus credenciales y notificarnos si sospechan acceso no autorizado."
        }
      ]
    },
    {
      "title": "12. Sus derechos",
      "blocks": [
        {
          "type": "p",
          "text": "Según las leyes aplicables, puede tener derecho a:"
        },
        {
          "type": "ul",
          "items": [
            "Acceder a sus datos",
            "Solicitar rectificación",
            "Solicitar supresión",
            "Oponerse a ciertos tratamientos",
            "Solicitar limitación",
            "Retirar el consentimiento",
            "Solicitar portabilidad",
            "Presentar una reclamación ante una autoridad competente"
          ]
        },
        {
          "type": "p",
          "text": "Para ejercer sus derechos, contáctenos en:"
        },
        {
          "type": "p",
          "text": "support@demaxtore.com"
        },
        {
          "type": "p",
          "text": "Podemos necesitar verificar su identidad antes de responder."
        }
      ]
    },
    {
      "title": "13. WhatsApp y otros canales de comunicación",
      "blocks": [
        {
          "type": "p",
          "text": "Si nos contacta por WhatsApp, correo electrónico, SMS, teléfono u otros canales, podemos tratar y almacenar el contenido y la información de contacto relacionada."
        },
        {
          "type": "p",
          "text": "Esto nos ayuda a:"
        },
        {
          "type": "ul",
          "items": [
            "Responder a su solicitud",
            "Proporcionar soporte",
            "Gestionar relaciones con compradores, proveedores y socios",
            "Coordinar abastecimiento, flete, inspección o envío",
            "Mantener registros comerciales"
          ]
        },
        {
          "type": "p",
          "text": "Las herramientas de terceros también pueden tratar sus datos según sus propias políticas."
        }
      ]
    },
    {
      "title": "14. Operaciones comerciales",
      "blocks": [
        {
          "type": "p",
          "text": "Si DeMaxtore participa en una fusión, adquisición, inversión, reestructuración, venta de activos u operación similar, los datos personales pueden transferirse o divulgarse cuando la ley lo permita."
        },
        {
          "type": "p",
          "text": "En tal caso, tomaremos medidas adecuadas para proteger los datos."
        }
      ]
    },
    {
      "title": "15. Datos de menores",
      "blocks": [
        {
          "type": "p",
          "text": "DeMaxtore ofrece servicios B2B y no está dirigido a niños."
        },
        {
          "type": "p",
          "text": "No recopilamos conscientemente datos de menores de 18 años. Si tenemos conocimiento de ello, tomaremos medidas razonables para eliminarlos."
        }
      ]
    },
    {
      "title": "16. Actualizaciones de este aviso",
      "blocks": [
        {
          "type": "p",
          "text": "Podemos actualizar este aviso de privacidad del sitio web para reflejar cambios en nuestros servicios, requisitos legales, operaciones o prácticas de tratamiento."
        },
        {
          "type": "p",
          "text": "La versión más reciente se publicará en www.demaxtore.com con la fecha actualizada."
        }
      ]
    },
    {
      "title": "17. Contáctenos",
      "blocks": [
        {
          "type": "p",
          "text": "Para preguntas, solicitudes o inquietudes sobre este aviso o cómo tratamos datos personales, contáctenos:"
        },
        {
          "type": "ul",
          "items": [
            "Demakstore Gıda İhracat San. ve Tic. Ltd. Şti.",
            "Marca operativa: DeMaxtore",
            "Sitio web: www.demaxtore.com",
            "Correo electrónico: support@demaxtore.com",
            "Correo alternativo: demaxtore@demaxtore.com"
          ]
        }
      ]
    }
  ]
};
